// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFilterFromJSON, DatapointFilterToJSON, DatapointsExcelRequestItemFromJSON, DatapointsExcelRequestItemToJSON, } from './';
export function DatapointsComparisonExcelRequestAllOfFromJSON(json) {
    return {
        'requests': !exists(json, 'requests') ? undefined : json['requests'].map(DatapointsExcelRequestItemFromJSON),
        'filters': !exists(json, 'filters') ? undefined : json['filters'].map(DatapointFilterFromJSON),
        'differenceSheetOnly': !exists(json, 'differenceSheetOnly') ? undefined : json['differenceSheetOnly'],
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
    };
}
export function DatapointsComparisonExcelRequestAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'requests': value.requests === undefined ? undefined : value.requests.map(DatapointsExcelRequestItemToJSON),
        'filters': value.filters === undefined ? undefined : value.filters.map(DatapointFilterToJSON),
        'differenceSheetOnly': value.differenceSheetOnly,
        'entityName': value.entityName,
    };
}
